<template>
  <div class="mt-16 text-center">
    <div class="title-lg text-gray-92">URLの有効期限が切れています。</div>
    <div class="mt-4 body-md text-gray-92">
      もう一度、はじめからやり直してください。
    </div>

    <div class="mt-6">
      <router-link :to="{ name: 'Login' }" class="inline-block">
        <button
          class="button-md rounded-lg bg-white border border-gray-38 px-4 py-2 text-gray-92 hover:bg-gray-04 focus:bg-gray-12 active:bg-gray-10"
        >
          ログインページへ
        </button>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  setup() {
    return {};
  },
};
</script>
